<template>
  <div>
    <div class="container">
      <iframe :src="src" scrolling="no" frameborder="0"></iframe>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
export default {
  data() {
    return {
      src:
        "static/wetlandsMap/xhindex.html?url10=" +
        this.$store.state.Url10 +
        "&url8=" +
        this.$store.state.Url8 +
        "&url4=" +
        this.$store.state.Url4 +
        "&url7=" +
        this.$store.state.Url7 +
        "&soid=" +
        this.$store.state.Soid +
        "&isDevelopmentEnvironment=" +
        this.$store.state.isDevelopmentEnvironment
    };
  },
  components: {},
  mounted() {
    sessionStorage.initExtent = JSON.stringify(this.$store.state.initExtent);
    $(".container").height(
      $(window).height() -
        $(".header_box").height() -
        1
    );
  }
};
</script>

<style scoped="scoped">
.container iframe {
  display: block;
  width: 100%;
  height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/patrolDisplay/patrolDisplay.vue